module.exports = global["jQuery"] = require("-!/home/idiomas.uach.mx/tmp/build-162854319028799/node_modules/expose-loader/index.js?$!./jquery.js");